var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import ServiceBase from "@/common/services/serviceBase";
import { RecordState } from "@/common/types/RecordState";
var EntityService = /** @class */ (function (_super) {
    __extends(EntityService, _super);
    function EntityService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EntityService.prototype.getActiveTasks = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTasks(false)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    EntityService.prototype.getHistoricalTasks = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getTasks(true)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    EntityService.prototype.getTasks = function (getHistory) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/records?getHistoricalEntries=" + getHistory, this.factory.createGet())];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: throw new Error("Fetching tasks failed.");
                }
            });
        });
    };
    EntityService.prototype.getAidYearPurpose = function (aidYearId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/aidyear/" + aidYearId + "/purpose", this.factory.createGet())];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.text()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: throw new Error("Fetching aidyear failed.");
                }
            });
        });
    };
    EntityService.prototype.getAidTargetsForExtension = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/aidtarget/aidtargets-for-extension", this.factory.createGet())];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: throw new Error("Fetching aidtargets failed.");
                }
            });
        });
    };
    EntityService.prototype.getPreviouslyClearedExpenditure = function (reportId, aidYearId) {
        return __awaiter(this, void 0, Promise, function () {
            var response, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/paymentrequestexpensereport/" + reportId + "/" + aidYearId + "/previously-cleared", this.factory.createGet())];
                    case 1:
                        response = _b.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        _a = Number;
                        return [4 /*yield*/, response.text()];
                    case 2: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                    case 3: throw new Error("Fetching previously cleared failed.");
                }
            });
        });
    };
    EntityService.prototype.getCorrespondences = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/correspondences", this.factory.createGet())];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: throw new Error("Fetching correspondences failed.");
                }
            });
        });
    };
    EntityService.prototype.getCorrespondencesCount = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/correspondence/count", this.factory.createGet())];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: throw new Error("Fetching correspondences count failed.");
                }
            });
        });
    };
    EntityService.prototype.getPaymentsData = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/payment", this.factory.createGet())];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: throw new Error("Failed to get payments");
                }
            });
        });
    };
    EntityService.prototype.getCorrespondence = function (referenceId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/correspondence/" + referenceId, this.factory.createGet())];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: throw new Error("Failed to get correspondence");
                }
            });
        });
    };
    EntityService.prototype.sendCorrespondence = function (item) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/correspondence/send-correspondence", this.factory.createPut(JSON.stringify(item)))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    EntityService.prototype.getLockState = function (id, section, appId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/sectionlock/" + id + "/" + section + "?appId=" + appId, this.factory.createGet())];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    EntityService.prototype.postSectionLock = function (id, section, appId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/locksection/" + id + "/" + section + "?appId=" + appId, this.factory.createPost(""))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    EntityService.prototype.clearSectionLock = function (id, section, appId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/clearsectionlock/" + id + "/" + section + "?appId=" + appId, this.factory.createDelete(""))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    EntityService.prototype.autoSaveUpdate = function (recordable, section, appId) {
        return __awaiter(this, void 0, Promise, function () {
            var recordType, recordId, string;
            return __generator(this, function (_a) {
                recordType = recordable.record.recordType;
                recordId = recordable.record.id;
                string = JSON.stringify(recordable);
                return [2 /*return*/, this.fetchApi("/api/" + recordType + "/" + recordId + "/" + section + "?appId=" + appId, this.factory.createPut(string), 5000).then(function (response) {
                        if (response.ok) {
                            recordable.record.state = RecordState.OpenInWeb;
                        }
                        return response;
                    }, function () {
                        return null;
                    })];
            });
        });
    };
    EntityService.prototype.send = function (recordType, recordId, language) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/" + recordType + "/" + recordId + "/submit?language=" + language, this.factory.createPut(""))];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: throw new Error("Failed to submit " + recordType);
                }
            });
        });
    };
    EntityService.prototype.sendPeriod = function (recordType, recordId, periodId, language) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/" + recordType + "/" + recordId + "/" + periodId + "/submitPeriod?language=" + language, this.factory.createPut(""))];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 2];
                        return [2 /*return*/, []];
                    case 2:
                        if (!(response.status == 400)) return [3 /*break*/, 4];
                        return [4 /*yield*/, response.json()];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4: throw new Error("Failed to submit " + recordType);
                }
            });
        });
    };
    EntityService.prototype.markAsRead = function (recordType, recordId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/" + recordType + "/mark-as-read/" + recordId, this.factory.createPut(""))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.ok];
                }
            });
        });
    };
    EntityService.prototype.sendArchiveReportRequest = function (id) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetchApi("/api/pdf/archivereport/" + id, this.factory.createGet(), 5000).then(function (response) {
                        return response;
                    }, function () {
                        return null;
                    })];
            });
        });
    };
    EntityService.prototype.createERPR = function (context) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/paymentrequestexpensereport/" + context.aidTargetId, this.factory.createPost(JSON.stringify(context)))];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: throw new Error("Failed to create payment request / expense report.");
                }
            });
        });
    };
    EntityService.prototype.createDeadlineChange = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/deadlinechange/new", this.factory.createPost(""))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    EntityService.prototype.createAidApplication = function (aidTypeId, aidTargetId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/aidapplication/" + aidTypeId + "/" + (aidTargetId ? aidTargetId : ''), this.factory.createPost(""))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    EntityService.prototype.initializeContinuousReportTargetGroups = function (recordId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/continuousreport/" + recordId, this.factory.createPost(""))];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: throw new Error("Failed to initialize continuous report target groups.");
                }
            });
        });
    };
    EntityService.prototype.deleteRecord = function (recordType, recordId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/" + recordType + "/delete/" + recordId, this.factory.createDelete(""))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get record validation errors
     * @param recordType recordable type
     * @param recordId record id
     */
    EntityService.prototype.validationErrors = function (recordType, recordId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/" + recordType + "/" + recordId + "/validationerrors", this.factory.createGet())];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: throw new Error("Failed to get validation errors");
                }
            });
        });
    };
    /**
     * Gets recordable from server.
     * @param recordType type of the record.
     * @param recordId id of the record.
     */
    EntityService.prototype.getRecordable = function (recordType, recordId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/" + recordType + "/" + recordId, this.factory.createGet())];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: throw new Error("Failed to get recordable");
                }
            });
        });
    };
    EntityService.prototype.updatePeriod = function (period, periodType, recordId, appId, recordable) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.fetchApi("/api/continuousReport/" + recordId + "/" + periodType + "?appId=" + appId, this.factory.createPut(JSON.stringify(period)), 5000).then(function (response) {
                        if (response.ok) {
                            recordable.record.state = RecordState.OpenInWeb;
                        }
                        return response;
                    }, function () {
                        return null;
                    })];
            });
        });
    };
    EntityService.prototype.addTargetGroup = function (targetGroup, recordId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/continuousReport/" + recordId + "/targetGroup", this.factory.createPost(JSON.stringify(targetGroup)))];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error("Failed to add target group");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    EntityService.prototype.deleteTargetGroup = function (targetGroup, recordId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchApi("/api/continuousReport/" + recordId + "/targetGroup", this.factory.createDelete(JSON.stringify(targetGroup)))];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            throw new Error("Failed to delete target group");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return EntityService;
}(ServiceBase));
export default EntityService;
